export class LogNodeModel {
  public itemId: string;
  public parentItemId: string;
  public parentName: string;
  public parentFullPath: string;
  public name: string;
  public fullPath: string;
  public nodeType: string
  public levelNo: number;
  public orderNo: string
  public fileSizeInBytes: number;
}